module.exports = "/_next/static/images/og-image-velieve-min-598958b7da1027693f9194d337698879.jpg.webp";